import { Action } from "../../../types/action/action";
import { ActionDto } from "../../../types/action/action-dto";

export const convertActionDtoToAction = (actionDto: ActionDto): Action => {
  return {
    startTimeLimited: actionDto.startTimeLimited,
    endTimeLimited: actionDto.endTimeLimited,
    requirement: actionDto.requirement,
    estimatedTimeOfArrival: actionDto.estimatedTimeOfArrival,
    images: actionDto.images,
    issueStatus: actionDto.issueStatus,
    startedAt: actionDto.startedAt,
    completedAt: actionDto.completedAt,
    type: actionDto.type,
    memo: actionDto.memo,
    retryCount: actionDto.retryCount || 0,
  };
};
